import { Typography } from '@mui/material';
import { ArrowDownIcon } from '../../../assets/images';
import { MuiIconButton } from '../../../builderPackage/components';
import { MuiStack } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { getLocalStorageItem } from '../../../utils/storageHelper';
export default function LocationDetailCell(props) {
    var _props$row, _props$row2, _props$row3, _props$row4, _props$row5;
    var isMulitpleDoc = getLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC);
    var isDisable = isMulitpleDoc;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        style: {
            fontSize: '12px',
            fontWeight: 400,
            color: '#1B1D21'
        }
    }, (_props$row = props.row) !== null && _props$row !== void 0 && _props$row.LocationDetails ? (_props$row2 = props.row) === null || _props$row2 === void 0 || (_props$row2 = _props$row2.LocationDetails[0]) === null || _props$row2 === void 0 ? void 0 : _props$row2.LocationName : '')), ((_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.LocationDetails) && !((_props$row4 = props.row) !== null && _props$row4 !== void 0 && (_props$row4 = _props$row4.LocationDetails[0]) !== null && _props$row4 !== void 0 && _props$row4.LocationId) && /*#__PURE__*/ React.createElement(MuiIconButton, {
        onClick: props.onClick,
        style: {
            alignContent: 'flex-end'
        },
        disable: ((_props$row5 = props.row) === null || _props$row5 === void 0 || (_props$row5 = _props$row5.LocationDetails[0]) === null || _props$row5 === void 0 ? void 0 : _props$row5.LocationId) || isDisable
    }, /*#__PURE__*/ React.createElement("img", {
        src: ArrowDownIcon,
        alt: "Arrow Down"
    })));
}
